import React from 'react';
import ConfirmDialog from './ConfirmDialog.jsx';
import moment from 'moment';
import { connect } from 'react-redux';
import { Dialog } from "@blueprintjs/core";
import { ShowIf, ShowIfCheck } from 'components/utils';
import {
  DropDownChonCanBoGiaiQuyet,
  DropDownChonKetLuanNoiDungKhieuNai,
  DropDownKetQuaGiaiQuyetDon,
  DropDownChonCoQuanDieuTra,
  DropDownMulipleUse,
  DropDownNguoiKy
} from 'components/tt-forms';
import { TextArea, DatePicker, Input, InputNumber, Text, TextMessage } from 'components/tt-forms/common';
import { GiaiQuyetDonThu, Danhmuc, DuLieuHeThong } from 'api';
import { Link } from 'react-router';
import {ContainerFileDinhKem} from 'components/upload';
import {
  getParams
} from 'modules/giai-quyet-don/subView/GetParams.jsx';
import {checkThamSo} from "constants/checkThamSo";
import {BlockBaoCaoKQTTXM} from 'modules/giai-quyet-don/subView';
const vaiTro = 'CHUYEN_VIEN';
const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'GIAI_QUYET_DON';

class TruongPhongNhanBaoCaoTTXM extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      open: false,
      onSave: false,
      validate: false,
      id: this.props.id,
      role: this.props.roleGQ,
      loaiDon: this.props.loaiDon,
      gqText: (this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') ? 'Ban hành văn bản giải quyết' : ((this.props.loaiDon == 'DON_TO_CAO') ? 'Ban hành kết luận nội dung tố cáo' : 'Ban hành quyết định giải quyết'),
      openDialogLuuHoSo: false,
      openDialogGiaoDoiThoai: false,
      btnLoading: false,
      btnSaveLoading: false,
      focused: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTruongPhongTTXM: false,
      openDialogNoiChinh: false,
      openDialogVanPhong: false,
      yKienGiaiQuyet: '',
      canBoGiaiQuyet: '',
      phongBanGiaiQuyet: '',
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        quyetDinhGiaiQuyet: [],
        giaoCoQuanDieuTra: [],
        giaHan: [],
        data: []
      },

      dataNextStates: [],
      dataNextStatesFilter: [],
      dataTaiLieuVanThuDelete: [],
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
      coQuanQuanLyId: this.props.coQuanQuanLyId,
      coQuanQuanLyNguoiDung: this.props.coQuanQuanLyNguoiDung,
      nextState: '',
      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
      dataPhongBan: [],
      dataPhongBanFilter: [],
      dataCanBoGiaiQuyet: [],
      dataThamSo: -1,

      giaoCoQuanDieuTra: false,
      theoDoiThucHien: false,
      khoiTo: false,
      showTienDoGiaiQuyet: false,

      ketQuaXLDGiaiQuyet: '',
      ketQuaXLDGiaiQuyetInit: '',

      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',

      taiLieuVanThuGiaoCoQuanDieuTra: [],

      coQuanDieuTra: '',
      soVuGiaoCoQuanDieuTra: '',
      soDoiTuongGiaoCoQuanDieuTra: '',

      tienPhaiThuNhaNuoc: '',
      datPhaiThuNhaNuoc: '',
      tienPhaiTraCongDan: '',
      datPhaiTraCongDan: '',

      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',

      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',

      soVuBiKhoiTo: '',
      soDoiTuongBiKhoiTo: '',

      tienDaThuNhaNuoc: '',
      datDaThuNhaNuoc: '',
      tienDaTraCongDan: '',
      datDaTraCongDan: '',

      soVuGiaiQuyetKhieuNai: '',

      soLanGiaiQuyetLai: '',
      ketQuaGiaiQuyetLan2: '',
      noiDungKetLuanGiaiQuyetLai: '',

      ketQuaGiaiQuyetKhac: '',
      ketQuaThucHienKhac: '',

      allowAttach: false,
      allowHuongGiaiQuyetFillter: false,
      allowAttachGiaoCoQuanDieuTra: false,
      checkDonViPhongBanKhac: false,

      doiThoai: false,
      thoiGianDoiThoai: '',
      diaDiemDoiThoai: '',

      dataDonViTheoDoi: [],
      dataCoQuanTheoDoi: [],
      dataDonViNhanTDTH: [],
      donViTheoDoiThucHien: '',
      tenDonViTheoDoiThucHien: '',
      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: '',
      setHuongGiaiQuyet: false,
      typeButton: '',
      isUBND: false,
      checkUBND: false,
      setDataCanBo: false,
      ngayHetHanGiaiQuyetTTXMLai: '',
      ngayHetHanTTXMLai: '',
      noiDungGiaoTTXMLai: '',
      openDialogGiaoTTXML: false,
      valueKetQua: '',
      message: '',
      lyDoBanHanhQuyetDinhDinhChi: '',
      lyDoBanHanhQuyetDinhGiaiQuyet: '',
      ngayRaThongBaoTTXM: '',
      loaiVanBanSuggest: '',
      ngayQuyetDinhSuggest: ''
    }
  }

  checkVaiTro() {
    let ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

    if (ThamSo.length > 0 && userInfo != {}) {
      if (checkThamSo() != null) {
        return false
      } else {
        return true
      }
    } else {
      return false
    }
  }

  getCanBoGiaiQuyet() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let params = {
      coQuanQuanLyId: userInfo.coQuanQuanLyId,
      vaiTro: vaiTro,
      page: 0,
      size: 1000,
      sort: 'ten,desc'
    }

    DuLieuHeThong.actions.getChuyenVienThuocPhongBan.request(params).then(res => {
      if (res.data._embedded) {
        this.setState({
          dataCanBoGiaiQuyet: res.data._embedded.congChucs
        }, () => {
          this.setState({
            setDataCanBo: true
          })
        });
      } else {
        this.setState({
          setDataCanBo: true
        })
      }
    });
  }

  componentDidMount() {
    this.getCanBoGiaiQuyet()
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    this.getPhongBanThuocCoQuan();
    this.getCoQuanTheoDoiEnumn();
    this.getDonViNhanTDTH();
    this.getListDonViNhanTDTH();
    this.getThoiHanGQDonMacDinh();
    this.getThoiHanTTXMMacDinh();
    if(this.props.nhanDuThao == true) {
      this.setState({
        nextState: 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_DU_THAO'
      })
    }
    if(this.props.dataNextStates) {
      let data = [...this.props.dataNextStates];
      data = data.filter(props => {
        return props.type !== 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO' &&
          props.type !== 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN' &&
          props.type !== 'CAN_BO_GIAO_TTXM_LAI'
      });
      /* if (checkThamSo() == 'CQQL_PHONG_NOI_CHINH') {
        data = data.filter(props => {
          return props.type != 'TRUONG_PHONG_NHAN_KET_QUA_TTXM'
        });
      } */
      if (checkThamSo() === 'CQQL_BAN_TIEP_CONG_DAN') {
        data = data.filter(props => props.type !== "TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM");
      } else {
        let getPhongBan = data.find(item => item.type === "TRUONG_PHONG_NHAN_KET_QUA_TTXM");
        if (getPhongBan) {
          let phoPhong = {
            stateId : getPhongBan.stateId,
            ten: "Trưởng phòng giao việc phó phòng",
            tenVietTat: "Giao việc phó phòng",
            type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
          }
          data.push(phoPhong);
        }
      }
      data.map(item => {
        if (item.type == 'KET_THUC') {
          item.tenVietTat = 'Tự giải quyết';
          item.ten = 'Trưởng phòng tự giải quyết';
        }
      })
      this.setState({
        dataNextStates: data,
        dataNextStatesFilter: data
      });
    }

    this.getThamSo('CQQL_UBNDTP_DA_NANG');

    if (window.debug) {
      console.log('giai-quyet-don/subView/TruongPhongNhanBaoCaoTTXM');
    }
  }

  getThoiHanGQDonMacDinh() {
    DuLieuHeThong.actions.getThoiHanGQDonMacDinh.request(null, {type: this.props.loaiDon}).then(res => {
      let thoiHanXuLyMacDinh = new Date(res.data);
      this.setState({
        ngayHetHanGiaiQuyetTTXMLai: thoiHanXuLyMacDinh
      })
    })
  }

  getThoiHanTTXMMacDinh() {
    let params = {
      type: this.props.loaiDon
    }
    if ((this.props.loaiDon == 'DON_KHIEU_NAI' || this.props.loaiDon == 'DON_TO_CAO') && this.state.ngayRaThongBaoTTXM && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI') {
      params.ngayRaThongBaoTTXM = moment(this.state.ngayRaThongBaoTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    DuLieuHeThong.actions.getThoiHanTTXMMacDinh.request(null, params).then(res => {
      let thoiHanXuLyMacDinh = new Date(res.data);
      this.setState({
        ngayHetHanTTXMLai: thoiHanXuLyMacDinh
      })
    })
  }

  getDonViNhanTDTH() {
    let params = {
      donId: Number(this.state.id),
      loaiDon: this.state.loaiDon
    }
    GiaiQuyetDonThu.actions.getDonViNhanTDTH.request('', params).then(res => {
      if(res.data) {
        this.setState({
          donViTheoDoiThucHien: res.data.coQuanQuanLyId,
          tenDonViTheoDoiThucHien: res.data.ten
        })
      }
    })
  }

  getListDonViNhanTDTH() {
    GiaiQuyetDonThu.actions.getListDonViNhanTDTH.request().then(res => {
      if(res.data._embedded) {
        this.setState({
          dataDonViNhanTDTH: res.data._embedded.coQuanQuanLies
        })
      }
    })
  }

  getThamSo(thamSo) {
    let params={
      tuKhoa: thamSo
    }
    Danhmuc.actions.getThamSo.request(params).then(res => {
      if(res.data._embedded) {
        this.setState({
          dataThamSo: Number(res.data._embedded.thamSoes[0].giaTri)
        },()=>{
          this.checkThamSoUBND()
        })
      }
    })
  }

  checkThamSoUBND() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let isUBND = false;
    if(userInfo.donViId == this.state.dataThamSo) {
      isUBND = true;
    }
    this.setState({
      isUBND: isUBND
    },() => {
      this.setState({
        checkUBND: true
      })
    })
  }

  getCoQuanTheoDoiEnumn() {
    GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(res => {
      if (res.data) {
        this.setState({
          dataCoQuanTheoDoi: res.data
        })
      }
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.truongPhongThuHoi == true) {
      if (this.select && prevState.focused == false) {
        this.setState({
          focused: true
        })
        this.select.focus();
      }
    }

    if (this.state.checkDonViPhongBanKhac == true) {
      let dataOption = this.state.dataNextStates;
      let indexOption = dataOption.findIndex(x => x.type == 'TRUONG_PHONG_NHAN_KET_QUA_TTXM')
      if (indexOption != -1 && this.state.dataPhongBan.length == 0) {
        let newOption = [...this.state.dataNextStates];
        newOption.splice(indexOption, 1);
        this.state.dataNextStates = newOption;
        this.setState({
          ...this.state
        })
      }
    }

    this.checkHuongGiaiQuyet();
  }

  getPhongBanThuocCoQuan() {
    GiaiQuyetDonThu.actions.getPhongBanThuocCoQuan.request().then(res => {
      if(res.data._embedded) {
        let ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
        let dataThamSo = [];
        let dataFilter = [];
        ThamSo.map(item => {
          dataThamSo[dataThamSo.length] = item.giaTri
        })
        if (ThamSo.length > 0) {
          let data = [...res.data._embedded.coQuanQuanLies];
          dataFilter = data.filter(state => {
            return dataThamSo.indexOf(state.coQuanQuanLyId) == -1;
          })
        }
        this.state.dataPhongBan = res.data._embedded.coQuanQuanLies;
        this.state.dataPhongBanFilter = dataFilter;
        this.state.checkDonViPhongBanKhac = true;
        this.setState({
          ...this.state
        })
      } else {
        this.state.checkDonViPhongBanKhac = true;
        this.setState({
          ...this.state
        })
      }
    })
  }

  handleCheck(name, e) {
    this.setState({
      [name]: e
    })
    if (name =='giaoCoQuanDieuTra') {
      this.checkFileCoQuanDieuTra();
    }
    if (!e) {

    }
    this.props.handleChangeData();
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.dataNextStates) {
      let data = [...nextProps.dataNextStates];
      data = data.filter(props => {
        return props.type !== 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO' &&
          props.type !== 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN' &&
          props.type !== 'CAN_BO_GIAO_TTXM_LAI'
      });
      /* if (checkThamSo() == 'CQQL_PHONG_NOI_CHINH') {
        data = data.filter(props => {
          return props.type != 'TRUONG_PHONG_NHAN_KET_QUA_TTXM'
        });
      } */
      if (checkThamSo() === 'CQQL_BAN_TIEP_CONG_DAN') {
        data = data.filter(props => props.type !== "TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM");
      } else {
        let getPhongBan = data.find(item => item.type === "TRUONG_PHONG_NHAN_KET_QUA_TTXM");
        let getPhoPhong = data.find(item => item.type === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG");
        if (getPhongBan && !getPhoPhong) {
          let phoPhong = {
            stateId : getPhongBan.stateId,
            ten: "Trưởng phòng giao việc phó phòng",
            tenVietTat: "Giao việc phó phòng",
            type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
          }
          data.push(phoPhong);
        }
      }

      data.map(item => {
        if (item.type == 'KET_THUC') {
          item.tenVietTat = 'Tự giải quyết';
          item.ten = 'Trưởng phòng tự giải quyết';
        }
      })
      this.setState({
        dataNextStates: data,
        dataNextStatesFilter: data
      });
    }
  }

  resetData() {
    this.setState({
      canBoGiaiQuyet: '',

      thoiGianDoiThoai:'',
      diaDiemDoiThoai:'',
      ketQuaXLDGiaiQuyet: '',
      coQuanDieuTra:'',
      soVuGiaoCoQuanDieuTra: 0,
      soDoiTuongGiaoCoQuanDieuTra: 0,

      tienPhaiThuNhaNuoc: 0,
      datPhaiThuNhaNuoc: 0,
      tienPhaiTraCongDan: 0,
      datPhaiTraCongDan: 0,
      tongSoNguoiXuLyHanhChinh: 0,
      soNguoiDaBiXuLyHanhChinh: 0,

      hinhThucTheoDoi:'',
      coQuanTheoDoi:'',
      ketQuaThucHienTheoDoi:'',

      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: '',

      soVuBiKhoiTo: 0,
      soDoiTuongBiKhoiTo: 0,

      tienDaThuNhaNuoc: 0,
      datDaThuNhaNuoc: 0,
      tienDaTraCongDan: 0,
      datDaTraCongDan: 0,

      khoiTo:false,
      doiThoai: false,
      giaoCoQuanDieuTra:false,
      quyetDinhGiaiQuyetKhieuNai:false,
      theoDoiThucHien:false,

      tienPhaiThuNhaNuocQDGQ: 0,
      tienPhaiTraCongDanQDGQ: 0,
      datPhaiThuNhaNuocQDGQ: 0,
      datPhaiTraCongDanQDGQ: 0,
      soNguoiDuocTraLaiQuyenLoi: 0,

      soVuGiaiQuyetKhieuNai: 0,

      soLanGiaiQuyetLai: 0,
      ketQuaGiaiQuyetLan2:'',
      noiDungKetLuanGiaiQuyetLai:'',

      ketQuaGiaiQuyetKhac:'',
      ketQuaThucHienKhac:'',
      noiDungDoiThoai:'',
      noiDungGiaoLapDuThao:'',

      yKienGiaiQuyet: ''
    });
    this.renderAttachFile();
  }

  componentWillUnmount() {

  }

  onChange(name, e) {
    if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
      this.state.message = `Chọn "${this.state.gqText}" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?`;
      this.state.open =true;
      this.state.valueKetQua = e.target.value;
      this.setState({
        ...this.state
      })
    } else if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
      this.state.message = 'Chọn "Ban hành quyết định đình chỉ" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?';
      this.state.open =true;
      this.state.valueKetQua = e.target.value;
      this.setState({
        ...this.state
      })
    } else {
      this.setState({
        [name]: e.target.value
      }, ()=> {
        if (name == 'ketQuaXLDGiaiQuyet' || name == 'nextState' || name == 'hinhThucTheoDoi') {

        }
        if (name == 'ketQuaXLDGiaiQuyet' && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI') {
          this.renderAttachFile();
        }
        if (name == 'nextState') {
          this.resetData();
        }
      });
    }
    this.props.handleChangeData();
  }

  onFileChange(data, type) {
    let dataFileDinhKem = {...this.state.dataFileDinhKem};
    if (type == 'QUYET_DINH_GIAI_QUYET') {
      dataFileDinhKem.quyetDinhGiaiQuyet = data;
      let fileQD = data.filter(item => {
        return item.typeRequired == 'QDGQ_LDT'
      });
      this.setState ({ngayBanHanh: fileQD.length ? fileQD[0].ngayQuyetDinh : ''});
    } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
      dataFileDinhKem.giaoCoQuanDieuTra = data;
    } else if (type == 'GIA_HAN') {
      dataFileDinhKem.giaHan = data;
    } else {
      dataFileDinhKem.data = data;
      let ttxmlDate = data.filter(item => {
        return item.typeRequired == 'VB_GTTXML';
      });
      if (ttxmlDate.length) {
        this.state.ngayRaThongBaoTTXM = ttxmlDate[0].ngayQuyetDinh;
      }
      this.getThoiHanTTXMMacDinh();
    }
    this.setState ({
      dataFileDinhKem: dataFileDinhKem
    });
    this.props.handleChangeData();
  }

  onFileRemove(id, data, type) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });

    if (type == 'QUYET_DINH_GIAI_QUYET') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.quyetDinhGiaiQuyet = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaoCoQuanDieuTra = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type == 'GIA_HAN') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaHan = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    }
    this.props.handleChangeData();

  }

  getThongTinGiaiQuyetDon(id) {
    if(typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
      let params = {
        id: id
      };
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(res => {
        if(res.data) {
          this.setState({
            dataGiaiQuyetDon: res.data,

            nextState: res.data.phoPhong ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : (res.data.nextStateInfo ? res.data.nextStateInfo.type : (this.props.truongPhongThuHoi == true ? 'KET_THUC' : '')),

            canBoGiaiQuyet: res.data.canBoGiaiQuyetInfo ? res.data.canBoGiaiQuyetInfo.congChucId : '',
            yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',

            ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : (res.data.ketLuanNoiDungKhieuNaiGiaoTTXM || ''),

            doiThoai: res.data.doiThoai,
            thoiGianDoiThoai: res.data.thoiGianDoiThoai ? new Date(res.data.thoiGianDoiThoai) : '',
            diaDiemDoiThoai: res.data.diaDiemDoiThoai,

            coQuanDieuTra: res.data.coQuanDieuTraInfo ? res.data.coQuanDieuTraInfo.coQuanQuanLyId : '',
            soVuGiaoCoQuanDieuTra: res.data.soVuGiaoCoQuanDieuTra ? res.data.soVuGiaoCoQuanDieuTra : 0,
            soDoiTuongGiaoCoQuanDieuTra: res.data.soDoiTuongGiaoCoQuanDieuTra ? res.data.soDoiTuongGiaoCoQuanDieuTra : 0,

            soVanBan: res.data.soVanBan ? res.data.soVanBan : '',
            ngayBanHanh: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
            nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',

            tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
            datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
            tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
            datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
            tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
            soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,

            hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
            coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
            ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',

            khoiTo: res.data.khoiTo,
            soVuBiKhoiTo: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
            soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,

            tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
            datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
            tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
            datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,

            giaoCoQuanDieuTra: res.data.giaoCoQuanDieuTra,
            quyetDinhGiaiQuyetKhieuNai: res.data.quyetDinhGiaiQuyetKhieuNai,
            theoDoiThucHien: res.data.theoDoiThucHien,

            tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
            tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
            datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
            datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
            soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,
            phongBanGiaiQuyet: res.data.phongBanGiaiQuyetInfo ? res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
            soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,
            ketQuaXLDGiaiQuyet: res.data.ketQuaXLDGiaiQuyet ? res.data.ketQuaXLDGiaiQuyet : '',
            ketQuaXLDGiaiQuyetInit: res.data.ketQuaXLDGiaiQuyet ? res.data.ketQuaXLDGiaiQuyet : '',
            showTienDoGiaiQuyet: (res.data.ketQuaXLDGiaiQuyet && res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') ? true : false,
            lyDoBanHanhQuyetDinhGiaiQuyet: res.data.lyDoBanHanhQuyetDinhGiaiQuyet || '',
            lyDoBanHanhQuyetDinhDinhChi: res.data.lyDoBanHanhQuyetDinhDinhChi || '',

            soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
            ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
            noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',

            ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
            ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
            noiDungDoiThoai: res.data.noiDungDoiThoai ? res.data.noiDungDoiThoai : '',
            setHuongGiaiQuyet: false,
            noiDungGiaoTTXMLai: res.data.noiDungGiaoTTXMLai || ''
          }, ()=> {
            this.checkOnlyState();
            this.renderAttachFile();
            this.checkFileCoQuanDieuTra()
          });
          if (res.data.ngayHetHanGiaiQuyetTTXMLai) {
            this.setState({ngayHetHanGiaiQuyetTTXMLai: new Date(res.data.ngayHetHanGiaiQuyetTTXMLai)});
          }
          if (res.data.ngayHetHanTTXMLai) {
            this.setState({ngayHetHanTTXMLai: new Date(res.data.ngayHetHanTTXMLai)});
          }
        }
      });
    }
  }

  checkOnlyState() {
    if(this.props.dataNextStates.length == 1) {
      this.setState({
        nextState: this.props.dataNextStates[0].type
      }, ()=> {
        this.renderAttachFile();
      })
    }
  }

  onClickClose() {
    this.props.handleBack();
  }

  handleChangeDate(name, e) {
    let date = e;
    if (e && e._d) {
      date = e._d;

    }
    this.setState({
      [name]: date
    }, () => {
      if (name == 'ngayRaThongBaoTTXM') {
        this.setState({
          loaiVanBanSuggest: 'VB_GTTXML',
          ngayQuyetDinhSuggest: this.state.ngayRaThongBaoTTXM
        });
        this.getThoiHanTTXMMacDinh();
      }
      this.props.handleChangeData();
    });
  }

  getParams() {
    let dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
    let params = getParams(dataGiaiQuyetDon, this.state.id);

    if(this.state.doiThoai && this.state.loaiDon == 'DON_TO_CAO') {
      params.doiThoai = true;
      params.thoiGianDoiThoai = this.state.thoiGianDoiThoai ? moment(this.state.thoiGianDoiThoai).add(7, 'hours').toISOString() : null;
      params.diaDiemDoiThoai = this.state.diaDiemDoiThoai;
      params.noiDungDoiThoai = this.state.noiDungDoiThoai;
    } else {
      params.doiThoai = false;
      params.thoiGianDoiThoai = null;
      params.diaDiemDoiThoai = '';
      params.noiDungDoiThoai = '';
    }

    if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
      params.quyetDinhGiaiQuyetKhieuNai = true;
      params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;
      params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
      params.ngayBanHanh = this.state.ngayBanHanh ? moment(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
      params.nguoiBanHanh = this.state.nguoiBanHanh ? {id: this.state.nguoiBanHanh} : null;

      params.tienPhaiThuNhaNuocQDGQ = Number(this.state.tienPhaiThuNhaNuocQDGQ);
      params.tienPhaiTraCongDanQDGQ = Number(this.state.tienPhaiTraCongDanQDGQ);
      params.datPhaiThuNhaNuocQDGQ = Number(this.state.datPhaiThuNhaNuocQDGQ);
      params.datPhaiTraCongDanQDGQ = Number(this.state.datPhaiTraCongDanQDGQ);

      params.soVuGiaiQuyetKhieuNai = Number(this.state.soVuGiaiQuyetKhieuNai);
      params.ketLuanNoiDungKhieuNai = this.state.ketLuanNoiDungKhieuNai ? this.state.ketLuanNoiDungKhieuNai : null;
      params.tongSoNguoiXuLyHanhChinh = Number(this.state.tongSoNguoiXuLyHanhChinh);
      params.soNguoiDaBiXuLyHanhChinh = Number(this.state.soNguoiDaBiXuLyHanhChinh);
      params.soNguoiDuocTraLaiQuyenLoi = Number(this.state.soNguoiDuocTraLaiQuyenLoi);
      params.lyDoBanHanhQuyetDinhGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;
    } else {
      params.quyetDinhGiaiQuyetKhieuNai = false;
      params.soVanBan = '';
      params.ngayBanHanh = null;
      params.nguoiBanHanh = null;

      params.soLanGiaiQuyetLai = 0;
      params.ketQuaGiaiQuyetKhac = '';

      params.ketQuaGiaiQuyetLan2 = null;
      params.noiDungKetLuanGiaiQuyetLai = '';

      params.tienPhaiThuNhaNuocQDGQ = 0;
      params.tienPhaiTraCongDanQDGQ = 0;
      params.datPhaiThuNhaNuocQDGQ = 0;
      params.datPhaiTraCongDanQDGQ = 0;

      params.soVuGiaiQuyetKhieuNai = 0;
      params.ketLuanNoiDungKhieuNai = null;
      params.tongSoNguoiXuLyHanhChinh = 0;
      params.soNguoiDaBiXuLyHanhChinh = 0;

      params.soNguoiDuocTraLaiQuyenLoi = 0;
    }

    if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
      params.lyDoBanHanhQuyetDinhDinhChi = this.state.lyDoBanHanhQuyetDinhDinhChi;
      params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
      params.ngayBanHanh = this.state.ngayBanHanh ? moment(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
      params.nguoiBanHanh = this.state.nguoiBanHanh ? {id: this.state.nguoiBanHanh} : null;
    }

    if (this.state.giaoCoQuanDieuTra) {
      params.giaoCoQuanDieuTra = true;
      params.coQuanDieuTra =  {
        id: Number(this.state.coQuanDieuTra)
      }
      params.soVuGiaoCoQuanDieuTra = Number(this.state.soVuGiaoCoQuanDieuTra);
      params.soDoiTuongGiaoCoQuanDieuTra = Number(this.state.soDoiTuongGiaoCoQuanDieuTra);

      if (this.state.khoiTo) {
        params.khoiTo = true;
        params.soVuBiKhoiTo = this.state.soVuBiKhoiTo;
        params.soDoiTuongBiKhoiTo = this.state.soDoiTuongBiKhoiTo;
      } else {
        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
      }
    } else {
      params.giaoCoQuanDieuTra = false;
      params.coQuanDieuTra = null;
      params.soVuGiaoCoQuanDieuTra = 0;
      params.soDoiTuongGiaoCoQuanDieuTra = 0;

      params.khoiTo = false;
      params.soVuBiKhoiTo = 0;
      params.soDoiTuongBiKhoiTo = 0;
    }

    if (this.state.ketQuaXLDGiaiQuyet) {
      params.ketQuaXLDGiaiQuyet = this.state.ketQuaXLDGiaiQuyet
    } else {
      params.ketQuaXLDGiaiQuyet = null
    }
    if (this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM') {
      params.ketQuaXLDGiaiQuyet = null;
    }
    let selectedState = this.state.dataNextStates.filter(state => {
      return state.type == this.state.nextState
    });

    if(selectedState.length > 0) {
      params.nextState = {
        id: selectedState[0].stateId
      }
    } else {
      params.nextState = null
    }

    if(this.state.canBoGiaiQuyet) {
      params.canBoGiaiQuyet = {
        id: Number(this.state.canBoGiaiQuyet)
      }
    } else {
      params.canBoGiaiQuyet = null
    }

    if(this.state.phongBanGiaiQuyet) {
      params.phongBanGiaiQuyet = {
        id: Number(this.state.phongBanGiaiQuyet)
      }
    } else {
      params.phongBanGiaiQuyet = null
    }
    if (this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
      params.phoPhong = true;
    } else {
      params.phoPhong = false;
    }

    if (this.state.nextState == 'KET_THUC' && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI') {
      params.ngayHetHanGiaiQuyetTTXMLai = this.state.ngayHetHanGiaiQuyetTTXMLai ? moment(this.state.ngayHetHanGiaiQuyetTTXMLai).add(7, 'hours').toISOString() : null;
      params.ngayHetHanTTXMLai = this.state.ngayHetHanTTXMLai ? moment(this.state.ngayHetHanTTXMLai).add(7, 'hours').toISOString() : null;
      params.noiDungGiaoTTXMLai = this.state.noiDungGiaoTTXMLai || '';
    }
    return params;
  }

  handleSave(type){
    this.setState({
      onSave: true
    }, () => {

      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      let dataFileDinhKem = this.getListDataFileDinhKem();
      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map((item, i) => {
          if (item.taiLieuVanThuId) {
            this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(this.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
              don: {
                id: Number(this.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });
      }

      if (!this.state.giaoCoQuanDieuTra) {
        let dataGCCDT = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
        dataGCCDT.filter(state => {
          return state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA'
        }).map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item.taiLieuVanThuId
          };
        });
      }
      if (this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        let dataQDGQ = [...this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ];
        dataQDGQ.filter(state => {
          return state.typeRequired == 'QDGQ_LDT'
        }).map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item.taiLieuVanThuId
          };
        });
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      let params = this.getParams();

      params.yKienGiaiQuyet = this.state.yKienGiaiQuyet;
      this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
        this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
          this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
            this.props.saveGiaiQuyetDon(params);
          });
        });
      });
    })
  }

  handleGiaiQuyetDon(type) {
    this.setState({
      onSave: false
    }, ()=> {
      if(this.validateSubmitForm()) {
        this.setState({
          isOpen: false,
          btnLoading: true
        });


        let dataFileDinhKem = this.getListDataFileDinhKem();
        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map((item, i) => {
            if (item.taiLieuVanThuId) {
              this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(this.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(this.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (!this.state.giaoCoQuanDieuTra) {
          let dataGCCDT = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
          dataGCCDT.filter(state => {
            return state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA'
          }).map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
          let dataQDGQ = [...this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ];
          dataQDGQ.filter(state => {
            return state.typeRequired == 'QDGQ_LDT'
          }).map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        let _params = this.getParams();
        let params = {};
        let msgName = '';

        let selectedState = this.state.dataNextStates.filter(state => {
          return state.type == this.state.nextState
        });

        if (type == 'giaoCanBo') {
          if (this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG') {
            params = {
              canBoXuLyChiDinh: {
                id: Number(this.state.canBoGiaiQuyet)
              },
              thongTinGiaiQuyetDon: {
                id: Number(this.state.thongTinGiaiQuyetDonId)
              },
              phongBanGiaiQuyet: {
                id : Number(this.state.coQuanQuanLyNguoiDung.id)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              phoPhong: true,
              yKienGiaiQuyet: this.state.yKienGiaiQuyet
            }
            msgName = 'gqdGiaoViec';
          } else {
            params = {
              canBoXuLyChiDinh: {
                id: Number(this.state.canBoGiaiQuyet)
              },
              thongTinGiaiQuyetDon: {
                id: Number(this.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: this.state.yKienGiaiQuyet
            }
            msgName = 'gqdGiaoViec';
          }
        } else if (type == 'openDialog') {
          selectedState = this.props.dataNextStates.filter(state => {
            return state.type == 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN'
          });
          _params.donViTheoDoiThucHien = {
            id: Number(this.state.donViTheoDoiThucHien)
          }
          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.props.thongTinGiaiQuyetDonId)
            },
            donViTheoDoiThucHien: {
              id: Number(this.state.donViTheoDoiThucHien)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            }
          }
          params.yKienGiaiQuyet = this.state.lyDoBanHanhQuyetDinhDinhChi;
          if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
            params.yKienGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;
          }
          msgName = 'gqdChuyenTheoDoi';
        } else if (type == 'openDialogNoiChinh' || type == 'openDialogVanPhong' || type == 'giaoPhongBan') {
          params = {
            phongBanGiaiQuyet: {
              id: Number(this.state.phongBanGiaiQuyet)
            },
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet
          }
          msgName = 'xldChuyenDon';
        } else if (type == 'openDialogGiaoTTXML') {
          selectedState = this.props.dataNextStates.filter(state => {
            return state.type == 'CAN_BO_GIAO_TTXM_LAI'
          });
          params = {
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            thongTinGiaiQuyetDon: {
              id: Number(this.props.thongTinGiaiQuyetDonId)
            },
            yKienGiaiQuyet: this.state.noiDungGiaoTTXMLai
          }
          msgName = 'guiTTXMLai';
          if (this.state.ngayRaThongBaoTTXM) {
            params.ngayRaThongBaoTTXM = moment(this.state.ngayRaThongBaoTTXM).add(7, 'hours').toISOString();
          }
        }
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.props.updateGiaiQuyetDon(_params, params, msgName);
            });
          });
        });
      }
    })
  }

  checkFileCoQuanDieuTra() {
    this.setState({
      allowAttachGiaoCoQuanDieuTra: false
    }, () => {
      if (this.state.giaoCoQuanDieuTra == false) {
        this.setState({
          allowAttachGiaoCoQuanDieuTra: true
        })
      } else {
        let taiLieuVanThuGiaoCoQuanDieuTra = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
        let data = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
        let dataCheck = data.filter(state => {
          return state.required && state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA'
        });

        if (dataCheck.length > 0) {
          this.setState({
            taiLieuVanThuGiaoCoQuanDieuTra: taiLieuVanThuGiaoCoQuanDieuTra,
            allowAttachGiaoCoQuanDieuTra: true
          })
        } else {
          let newItem = {
            ten: 'Văn bản về việc chuyển hồ sơ sang cơ quan điều tra',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'GIAO_CO_QUAN_DIEU_TRA',
            newFile: true
          }
          this.setState({
            taiLieuVanThuGiaoCoQuanDieuTra: [
              ...taiLieuVanThuGiaoCoQuanDieuTra,
              newItem
            ],
            allowAttachGiaoCoQuanDieuTra: true
          })
        }
      }
    })
  }

  getListDataFileDinhKem() {
    let dataFileDinhKem = []
    let Data = this.state.dataFileDinhKem;

    if (Data.data.length > 0) {
      Data.data.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.quyetDinhGiaiQuyet.length > 0 && (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) {
      Data.quyetDinhGiaiQuyet.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.giaoCoQuanDieuTra.length > 0 && this.state.giaoCoQuanDieuTra) {
      Data.giaoCoQuanDieuTra.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.giaHan.length > 0 && (this.state.giaHanGiaiQuyet)) {
      Data.giaHan.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    return dataFileDinhKem;
  }

  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
    this.props.handleChangeData();
  }

  openDialog(name) {
    if (this.validateSubmitForm()) {
      this.setState({
        [name]: true
      })
    }
  }

  closeDialog(name) {
    this.setState({
      [name]: false
    })
  }
  onSuccess(name) {
    this.closeDialog(name);
    this.handleGiaiQuyetDon(name);
  }

  closeDialogConfirm() {
    this.setState({
      open: false,
      ketQuaXLDGiaiQuyet: this.state.ketQuaXLDGiaiQuyet
    })
  }

  onSuccessDialogConfirm() {
    this.setState({
      open: false,
      ketQuaXLDGiaiQuyet: this.state.valueKetQua
    }, () => {
      this.renderAttachFile();
    })
  }

  compareDate(firstDate, secondDate, type) {
    var firstTime = firstDate.getTime();
    var secondTime = secondDate.getTime()

    if (firstTime > secondTime || (firstTime == secondTime && type == 'show')) {
      return true
    } else {
      return false
    }
  }

  renderAttachFile() {
    let DataTaiLieuVanThu = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
    let DataTaiLieuVanThuView = [...this.props.listTaiLieuVanThuGiaiQuyetDon];

    let listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(state => {
      return this.compareDate(new Date(state.ngayTao), new Date(this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), 'action');
    })

    let listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(state => {
      return this.compareDate(new Date(this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), new Date(state.ngayTao), 'show');
    });
    let dataTTXML = DataTaiLieuVanThu.filter(item => {
      return item.typeRequired == 'VB_GTTXML'
    });
    if (this.state.nextState == 'KET_THUC' && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' && !dataTTXML.length) {
      listTaiLieuVanThuGiaiQuyetDon = [...listTaiLieuVanThuGiaiQuyetDon, {
        ten: this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Văn bản xác minh nội dung kiến nghị, phản ánh lại' : 'Văn bản giao TTXM lại',
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: 'VB_GTTXML',
        newFile: true
      }];
    }

    this.setState({
      listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
      listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
      allowAttach: true
    })
  }

  checkHuongGiaiQuyet() {
    let ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if(this.state.nextState != '') {
      if (
        ThamSo.length > 0 &&
        userInfo != {} &&
        this.state.checkUBND &&
        this.state.setDataCanBo &&
        this.state.setHuongGiaiQuyet == false &&
          (
          this.state.loaiDon === 'DON_TO_CAO' ||
          this.state.loaiDon === 'DON_KIEN_NGHI_PHAN_ANH'
          )
        ) {

        if (this.state.isUBND && checkThamSo() === null && this.state.dataCanBoGiaiQuyet.length == 0) {
          this.setState({
            setHuongGiaiQuyet: true,
            allowHuongGiaiQuyet: false
          })
        } else if (this.state.isUBND && checkThamSo() === null) {
          this.setState({
            setHuongGiaiQuyet: true,
            allowHuongGiaiQuyet: false,
            allowHuongGiaiQuyetFillter: true,
          })
        } else if (checkThamSo() === null && this.props.dataNextStates.length > 1) {

          this.setState({
            setHuongGiaiQuyet: true,
            allowHuongGiaiQuyet: true
          })
        } else if (checkThamSo() === 'CQQL_BAN_TIEP_CONG_DAN') {
          this.setState({
            setHuongGiaiQuyet: true,
            allowHuongGiaiQuyet: false
          }, () => {
            this.checkPhongBan()
          })
        } else if (checkThamSo() === 'CQQL_PHONG_NOI_CHINH') {
          this.setState({
            setHuongGiaiQuyet: true,
            allowHuongGiaiQuyet: true
          })
        } else if (checkThamSo() === 'CQQL_VAN_PHONG_UBND_THANH_PHO') {
          this.setState({
            setHuongGiaiQuyet: true,
            allowHuongGiaiQuyet: true
          })
        }
      }
    } else {
      if (
        ThamSo.length > 0 &&
        userInfo != {} &&
        this.state.checkUBND &&
        this.state.setDataCanBo &&
        this.state.setHuongGiaiQuyet == false &&
          (
          this.state.loaiDon == 'DON_TO_CAO' ||
          this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH'
          )
        ) {

        if (this.state.isUBND && checkThamSo() == null && this.state.dataCanBoGiaiQuyet.length == 0) {
          this.setState({
            nextState: 'KET_THUC',
            ketQuaXLDGiaiQuyet: 'DA_CO_QUYET_DINH_GIAI_QUYET',
            setHuongGiaiQuyet: true,
            allowHuongGiaiQuyet: false
          })
        } else if (this.state.isUBND && checkThamSo() == null) {
          this.setState({
            setHuongGiaiQuyet: true,
            allowHuongGiaiQuyet: false,
            allowHuongGiaiQuyetFillter: true,
          })
        } else if (checkThamSo() == null && this.props.dataNextStates.length > 1) {
          this.setState({
            setHuongGiaiQuyet: true,
            allowHuongGiaiQuyet: true
          })
        } else if (checkThamSo() == 'CQQL_BAN_TIEP_CONG_DAN') {
          this.setState({
            nextState: 'TRUONG_PHONG_NHAN_KET_QUA_TTXM',
            setHuongGiaiQuyet: true,
            allowHuongGiaiQuyet: false,
            allowHuongGiaiQuyetFillter: true,
          }, () => {
            this.checkPhongBan()
          })
        } else if (checkThamSo() == 'CQQL_PHONG_NOI_CHINH') {
          this.setState({
            nextState: 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM',
            setHuongGiaiQuyet: true,
            allowHuongGiaiQuyet: true
          })
        } else if (checkThamSo() == 'CQQL_VAN_PHONG_UBND_THANH_PHO') {
          this.setState({
            nextState: 'TRUONG_PHONG_NHAN_KET_QUA_TTXM',
            setHuongGiaiQuyet: true,
            allowHuongGiaiQuyet: true
          })
        }
      }
    }
  }

  checkPhongBan() {
    let ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
    if (this.state.loaiDon == 'DON_TO_CAO') {
      let dataFilter = ThamSo.filter(state => {
        return state.ten == 'CQQL_PHONG_NOI_CHINH'
      })

      if (dataFilter.length > 0) {
        this.setState({
          phongBanGiaiQuyet: Number(dataFilter[0].giaTri),
          typeButton: 'PHONG_NOI_CHINH'
        })
      }
    } else if (this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') {
      let dataFilter = ThamSo.filter(state => {
        return state.ten == 'CQQL_VAN_PHONG_UBND_THANH_PHO'
      })

      if (dataFilter.length > 0) {
        this.setState({
          phongBanGiaiQuyet: Number(dataFilter[0].giaTri),
          typeButton: 'VAN_PHONG_UBND'
        })
      }
    }
  }

  render() {
    let ketQuaGiaiQuyetDon = this.state.dataGiaiQuyetDon.ketQuaXLDGiaiQuyetInfo ? this.state.dataGiaiQuyetDon.ketQuaXLDGiaiQuyetInfo.text: '';
    let lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    let lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
    return (
      <section className="wrap-block">
        <div className="row pl10 pr10">
          <div className="col-100 no-gutter">
            <BlockBaoCaoKQTTXM donInfo={this.props.donInfo} thongTinGQD={this.state.dataGiaiQuyetDon}/>

            <ShowIf condition={this.props.loaiDon == 'DON_TO_CAO' && this.state.dataGiaiQuyetDon.giaHanGiaiQuyet}>
              <div>
                <div className="col-100">
                  <h3 className="text-12 txt-upper txt-bold mb10 mt0">Gia hạn giải quyết tố cáo</h3>
                </div>
                <Text red={true} className="col-25 mb10" label="Gia hạn đến ngày:" value={this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet ? moment(this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
                <TextMessage className="col-100 mb5" label="Lý do gia hạn:" value={this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet ? this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet : ''}/>
              </div>
            </ShowIf>
          </div>
        </div>
        <div className="wrap-big-line pt5 pb20">
          <span className="big-border"></span>
        </div>
        <h2 className="title-14 mb15">Thông tin giải quyết</h2>
        <form className="form-action">
          <div className="row pl10 pr10">
            <ShowIf condition={this.state.allowHuongGiaiQuyet && this.state.ketQuaXLDGiaiQuyetInit != 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
              <DropDownMulipleUse
              onRef={select => (this.select = select)}
              className="col-25"
              donId={this.state.id}
              require
              isValid={this.state.validate}
              data={this.state.dataNextStates}
              bindValidator={this}
              disable={this.state.ketQuaXLDGiaiQuyet !== '' && this.state.ketQuaXLDGiaiQuyet !== 'GIAO_THAM_TRA_XAC_MINH_LAI' ? true : false}
              selectedValue={this.state.nextState}
              label="Hướng giải quyết"
              keyName='type'
              name="huongGiaiQuyet"
              valueName='tenVietTat'
              onChange={this.onChange.bind(this, 'nextState')}/>
            </ShowIf>
            <ShowIf condition={!this.state.showTienDoGiaiQuyet}>
              <ShowIf condition={this.state.allowHuongGiaiQuyetFillter}>
                <DropDownMulipleUse
                onRef={select => (this.select = select)}
                className="col-25"
                donId={this.state.id}
                require
                isValid={this.state.validate}
                data={this.state.dataNextStatesFilter}
                bindValidator={this}
                selectedValue={this.state.nextState}
                label="Hướng giải quyết"
                disable={this.state.ketQuaXLDGiaiQuyet !== '' && this.state.ketQuaXLDGiaiQuyet !== 'GIAO_THAM_TRA_XAC_MINH_LAI' ? true : false}
                keyName='type'
                name="huongGiaiQuyet"
                valueName='tenVietTat'
                onChange={this.onChange.bind(this, 'nextState')}/>
              </ShowIf>
            </ShowIf>
            <ShowIf condition={this.state.showTienDoGiaiQuyet}>
              <p className="attach-file-description mb10 pl5 pr5">Hướng giải quyết</p>
              <Text className="col-25 mb10" label='' value='Tự giải quyết'/>
            </ShowIf>
            <ShowIf condition={this.state.nextState == 'TRUONG_PHONG_NHAN_KET_QUA_TTXM'}>
              <ShowIf condition={this.state.typeButton != 'PHONG_NOI_CHINH' && this.state.typeButton != 'VAN_PHONG_UBND' && checkThamSo() != 'CQQL_VAN_PHONG_UBND_THANH_PHO'}>
                <DropDownMulipleUse
                  selectedValue={this.state.phongBanGiaiQuyet}
                  require
                  bindValidator={this}
                  className="col-25"
                  keyName='coQuanQuanLyId'
                  valueName='ten'
                  name="phongBanGiaiQuyet"
                  label="Phòng ban giải quyết"
                  data={this.state.dataPhongBan}
                  onChange={this.onChange.bind(this, 'phongBanGiaiQuyet')}
                />
              </ShowIf>
              <ShowIf condition={checkThamSo() == 'CQQL_VAN_PHONG_UBND_THANH_PHO'}>
                <DropDownMulipleUse
                  selectedValue={this.state.phongBanGiaiQuyet}
                  require
                  bindValidator={this}
                  className="col-25"
                  keyName='coQuanQuanLyId'
                  valueName='ten'
                  name="phongBanGiaiQuyet"
                  label="Phòng ban giải quyết"
                  data={this.state.dataPhongBanFilter}
                  onChange={this.onChange.bind(this, 'phongBanGiaiQuyet')}
                />
              </ShowIf>
              <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaChonCanBoGiaiQuyet"/>
            </ShowIf>
            <ShowIf condition={this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM'}>
              <DropDownChonCanBoGiaiQuyet
                selectedValue={this.state.canBoGiaiQuyet}
                require
                coQuanQuanLyId={this.state.coQuanQuanLyNguoiDung.id}
                vaiTro={vaiTro}
                bindValidator={this}
                className="col-25"
                label="Công chức giải quyết"
                onChange={this.onChange.bind(this, 'canBoGiaiQuyet')}
                name="dropdownChonCanBoGiaiQuyet"
              />
              <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaChonCanBoGiaiQuyet"/>
            </ShowIf>
            <ShowIf condition={this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"}>
              <DropDownChonCanBoGiaiQuyet
                isValid={this.state.validate}
                selectedValue={this.state.canBoGiaiQuyet}
                require
                vaiTro="PHO_PHONG"
                coQuanQuanLyId={this.state.coQuanQuanLyNguoiDung.id}
                bindvaiTroValidator={this}
                className="col-25"
                label="Chọn phó phòng"
                onChange={this.onChange.bind(this, 'canBoGiaiQuyet')}
                name="dropdownChonCanBoGiaiQuyet"
              />
              <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaChonCanBoGiaiQuyet"/>
            </ShowIf>
            <ShowIf condition={this.state.nextState == 'KET_THUC'}>

              <div className="col-100 mt5">
                <h2 className="title-12 mb10">Tiến độ giải quyết</h2>
                <div className="row pl10 pr10">
                  <p className="attach-file-description mb10 pl5 pr5">Tiến độ giải quyết cho biết giai đoạn giải quyết hiện tại của đơn</p>
                  <ShowIf condition={!this.state.showTienDoGiaiQuyet}>
                    <DropDownKetQuaGiaiQuyetDon name="tienDoDoiThoai" disable={this.state.ketQuaXLDGiaiQuyet != '' && this.state.ketQuaXLDGiaiQuyet != 'GIAO_THAM_TRA_XAC_MINH_LAI' ? true : false} confirm={true} className="col-25" selectedValue={this.state.ketQuaXLDGiaiQuyet} onChange={this.onChange.bind(this, 'ketQuaXLDGiaiQuyet')} isTTXMLai={this.props.isTTXMLai} loaiDon={this.props.loaiDon}/>
                  </ShowIf>
                  <ShowIf condition={this.state.showTienDoGiaiQuyet}>
                    <Text className="col-25 mb10" label='' value={ketQuaGiaiQuyetDon}/>
                  </ShowIf>
                </div>
              </div>

              <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' && !this.props.isTTXMLai}>
                <DatePicker require
                  className="col-25"
                  value={this.state.ngayHetHanGiaiQuyetTTXMLai}
                  label='Hạn giải quyết'
                  name="ngayHetHanGiaiQuyetTTXMLai"
                  startDate={moment(new Date()).subtract(1, "days")}
                  onChange={this.handleChangeDate.bind(this, 'ngayHetHanGiaiQuyetTTXMLai')}
                  bindValidator={this}
                  channel="formTaoDon" />
                {
                  this.props.loaiDon == 'DON_TO_CAO' &&
                  <DatePicker require
                    className="col-25"
                    value={this.state.ngayRaThongBaoTTXM}
                    label={'Ngày ra văn bản '+lb1+' lại'}
                    name="ngayRaThongBaoTTXM"
                    onChange={this.handleChangeDate.bind(this, 'ngayRaThongBaoTTXM')}
                    bindValidator={this}
                    channel="formTaoDon" />
                }
                <DatePicker require
                  className="col-25"
                  value={this.state.ngayHetHanTTXMLai}
                  label='Thời gian báo cáo kết quả'
                  name="ngayHetHanTTXMLai"
                  startDate={moment(new Date()).subtract(1, "days")}
                  onChange={this.handleChangeDate.bind(this, 'ngayHetHanTTXMLai')}
                  bindValidator={this}
                  channel="formTaoDon" />
                <TextArea
                  label="Ý kiến xử lý"
                  rows="3"
                  placeholder="Nhập ý kiến"
                  value={this.state.noiDungGiaoTTXMLai}
                  onChange={this.onChange.bind(this, 'noiDungGiaoTTXMLai')}
                  name="textareaYKienTTXM" />
              </ShowIf>

              <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
                <div className='col-100 mb5'>
                  <ShowIf condition={this.props.loaiDon == 'DON_TO_CAO'}>
                    <h3 className="txt-upper title-14 mt0 mb15">Quyết định giải quyết tố cáo</h3>
                  </ShowIf>
                  <ShowIf condition={this.props.loaiDon != 'DON_TO_CAO'}>
                    <h3 className="txt-upper title-14 mt0 mb15">Văn bản giải quyết kiến nghị, phản ánh</h3>
                  </ShowIf>

                  <div className="row pl10 pr10">
                    <Input triggeOnBlur={true} name="inputSoVanBan" className="col-25" label="Số văn bản" bindValidator={this} channel="formTaoDon" require value={this.state.soVanBan} onChange={this.onChange.bind(this, 'soVanBan')} maxLength={255}/>
                    <DatePicker className="col-25" label="Ngày ban hành" endDate={new Date()} bindValidator={this} channel="formTaoDon" require value={this.state.ngayBanHanh} onChange={this.handleChangeDate.bind(this, 'ngayBanHanh')} name="inputNgayBanHanh"/>
                    <DropDownNguoiKy selected={this.state.nguoiBanHanh} onChange={this.onChange.bind(this, 'nguoiBanHanh')} />
                    <TextArea value={this.state.lyDoBanHanhQuyetDinhGiaiQuyet} className="areal-wrap col-100" label={`Nội dung ${this.state.gqText}`} placeholder="Nhập ..." onChange={this.onChange.bind(this, 'lyDoBanHanhQuyetDinhGiaiQuyet')} name="lyDoBanHanhQuyetDinhGiaiQuyet"/>
                    <ShowIf condition={this.state.allowAttach}>
                      <div className="col-100 pt15">
                        <ContainerFileDinhKem loaiVanBanSuggest="QDGQ_LDT" name="QuyetDinhGiaiQuyet" ngayQuyetDinhSuggest={this.state.ngayBanHanh} soVanBanSuggest={this.state.soVanBan} onSave={this.state.onSave} loaiDon={this.state.loaiDon} phanLoaiQuyTrinh='QUYET_DINH_GIAI_QUYET' qDGQText='QDGQ_LDT' qDGQRequired={true} label="Danh sách văn bản xử lý" bindValidator={this} data={this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                      </div>
                    </ShowIf>
                  </div>

                  <div className="col-100 no-gutter pt10 pb20">
                    <span className="line-border"></span>
                  </div>

                  <div className="row pl10 pr10">
                    <InputNumber className="col-25 mb0-18" label="Số vụ" value={Number(this.state.soVuGiaiQuyetKhieuNai)} onChange={this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai')} name="soVuDonToCao"/>
                    <ShowIf condition={this.props.loaiDon == 'DON_TO_CAO'}>
                      <DropDownChonKetLuanNoiDungKhieuNai require bindValidator={this} channel="formTaoDon" loaiDon={this.state.loaiDon} label="Kết luận nội dung tố cáo" className="col-25" selectedValue={this.state.ketLuanNoiDungKhieuNai} onChange={this.onChange.bind(this, 'ketLuanNoiDungKhieuNai')} name="DropDownChonKetLuanNoiDungKhieuNai"/>
                    </ShowIf>
                    <ShowIf condition={this.props.loaiDon != 'DON_TO_CAO'}>
                      <DropDownChonKetLuanNoiDungKhieuNai require bindValidator={this} channel="formTaoDon" loaiDon={this.state.loaiDon} name="DropDownChonKetLuanNoiDungKhieuNai" label="Kết luận nội dung kiến nghị, phản ánh" className="col-25" selectedValue={this.state.ketLuanNoiDungKhieuNai} onChange={this.onChange.bind(this, 'ketLuanNoiDungKhieuNai')}/>
                    </ShowIf>
                    <Input className="col-25 mb0-18" label="Kết quả khác" name="ketQuaKhac" value={this.state.ketQuaGiaiQuyetKhac} onChange={this.onChange.bind(this, 'ketQuaGiaiQuyetKhac')}/>
                  </div>
                  <div className="row pl10 pr10 mb5">
                    <div className="col-50 no-gutter mb20">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                      <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienPhaiThuNhaNuocQDGQ} onChange={this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ')} name="tienPhaiThuDonToCao"/>
                      <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải thu đất (m2)" value={this.state.datPhaiThuNhaNuocQDGQ} onChange={this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ')} name="datPhaiThuDonToCao"/>
                    </div>
                    <div className="col-50 no-gutter mb20">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                      <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienPhaiTraCongDanQDGQ} onChange={this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ')} name="tienPhaiTraDonToCao"/>
                      <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải trả đất (m2)" value={this.state.datPhaiTraCongDanQDGQ} onChange={this.onChange.bind(this, 'datPhaiTraCongDanQDGQ')} name="datPhaiTraDonToCao"/>
                    </div>
                    <div className="col-100 no-gutter">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                      <InputNumber className="col-25 mb0-18" label="Tổng số người" value={Number(this.state.tongSoNguoiXuLyHanhChinh)} onChange={this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh')} name="tongSoNguoiXuLyDonToCao"/>
                      <InputNumber className="col-25 mb0-18" label="Số người đã bị xử lý" value={Number(this.state.soNguoiDaBiXuLyHanhChinh)} onChange={this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh')} name="soNguoiDaBiXuLyDonToCao"/>
                      <InputNumber className="col-25 mb0-18" label="Số người được trả lại quyền lợi" value={this.state.soNguoiDuocTraLaiQuyenLoi} onChange={this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi')} name="inputnumberSoNguoiTraQuyenLoi"/>
                    </div>
                  </div>
                  <div className="col-100 no-gutter pt5 pb15">
                    <span className="line-border"></span>
                  </div>
                </div>
                <div className="col-100">
                <ShowIfCheck label="Chuyển cơ quan điều tra(Nếu có)" onChange={this.handleCheck.bind(this, 'giaoCoQuanDieuTra')} checked={this.state.giaoCoQuanDieuTra}>
                  <div className="col-100 no-gutter mt5 pb5">
                    <h2 className="title-12 mb15">Chuyển cơ quan điều tra(Nếu có)</h2>
                    <div className="row pl10 pr10">
                      <DropDownChonCoQuanDieuTra name="DropDownChonCoQuanDieuTra" className="col-25 mb0-18" label="Tên cơ quan" isValid={this.state.isValid} bindValidator={this} require selectedValue={this.state.coQuanDieuTra} onChange={this.onChange.bind(this, 'coQuanDieuTra')}/>
                      <InputNumber className="col-25 mb0-18" name="soVuGiaoCoQuanDieuTra" label="Số vụ" value={Number(this.state.soVuGiaoCoQuanDieuTra)} onChange={this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra')}/>
                      <InputNumber className="col-25 mb0-18" name="soDoiTuongGiaoCoQuanDieuTra" label="Số đối tượng" value={Number(this.state.soDoiTuongGiaoCoQuanDieuTra)} onChange={this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra')} maxLength={255}/>
                      <ShowIf condition={this.state.allowAttachGiaoCoQuanDieuTra}>
                        <div className="col-100 pt15">
                          <ContainerFileDinhKem name="GiaoCQDT" onSave={this.state.onSave} phanLoaiQuyTrinh='GIAO_CO_QUAN_DIEU_TRA' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.taiLieuVanThuGiaoCoQuanDieuTra} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                        </div>
                      </ShowIf>
                    </div>
                  </div>
                  <div className="col-100 pt5 pb15">
                    <span className="line-border"></span>
                  </div>

                  <div className="col-100">
                    <ShowIfCheck label="Khởi tố" onChange={this.handleCheck.bind(this, 'khoiTo')} checked={this.state.khoiTo}>
                      <div className="col-100 no-gutter mt5 pb20">
                        <h2 className="title-12 mb15">Khởi tố</h2>
                        <div className="row pl10 pr10">
                          <div className="col-50 no-gutter">
                            <InputNumber className="col-50 mb0-18" name="soVuBiKhoiTo" label="Số vụ" value={this.state.soVuBiKhoiTo} onChange={this.onChange.bind(this, 'soVuBiKhoiTo')}/>
                            <InputNumber className="col-50 mb0-18" name="soDoiTuongBiKhoiTo" label="Số đối tượng" value={this.state.soDoiTuongBiKhoiTo} onChange={this.onChange.bind(this, 'soDoiTuongBiKhoiTo')} maxLength={255}/>
                          </div>
                        </div>
                      </div>
                    </ShowIfCheck>
                  </div>
                </ShowIfCheck>
              </div>
              </ShowIf>
              <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI'}>
                <div className="col-100">
                  <h3 className="txt-upper title-14 mt0 mb15">Quyết định đình chỉ</h3>

                  <div className="row pl10 pr10">
                    <Input triggeOnBlur={true} className="col-25" name="inputSoVanBan" label="Số văn bản" bindValidator={this} channel="formTaoDon" require value={this.state.soVanBan} onChange={this.onChange.bind(this, 'soVanBan')} maxLength={255}/>
                    <DatePicker className="col-25" label="Ngày ban hành" endDate={new Date()} bindValidator={this} channel="formTaoDon" require value={this.state.ngayBanHanh} onChange={this.handleChangeDate.bind(this, 'ngayBanHanh')} name="inputNgayBanHanh"/>
                    <DropDownNguoiKy selected={this.state.nguoiBanHanh} onChange={this.onChange.bind(this, 'nguoiBanHanh')} />
                    <TextArea value={this.state.lyDoBanHanhQuyetDinhDinhChi} className="areal-wrap col-100" label="Lý do đình chỉ" placeholder="Nhập lý do" onChange={this.onChange.bind(this, 'lyDoBanHanhQuyetDinhDinhChi')} bindValidator={this} channel="formTaoDon" require name="lyDoBanHanhQuyetDinhDinhChi" maxLength={1000}/>
                    <ShowIf condition={this.state.allowAttach}>
                      <div className="col-100 pt15">
                        <ContainerFileDinhKem loaiVanBanSuggest="QDGQ_LDT" name="QuyetDinhDinhChi" quyetDinh={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? true : false} ngayQuyetDinhSuggest={this.state.ngayBanHanh} soVanBanSuggest={this.state.soVanBan} onSave={this.state.onSave} loaiDon={this.state.loaiDon} phanLoaiQuyTrinh='QUYET_DINH_GIAI_QUYET' qDGQText='QDGQ_LDT' qDGQRequired={true} label="Danh sách văn bản xử lý" bindValidator={this} data={this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                      </div>
                    </ShowIf>
                  </div>

                  <div className="col-100 no-gutter pt10 pb20">
                    <span className="line-border"></span>
                  </div>

                  <div className="col-100">
                    <ShowIfCheck label="Chuyển cơ quan điều tra" onChange={this.handleCheck.bind(this, 'giaoCoQuanDieuTra')} checked={this.state.giaoCoQuanDieuTra}>
                      <div className="col-100 no-gutter mt5 pb5">
                        <h2 className="title-12 mb15">Chuyển cơ quan điều tra</h2>
                        <div className="row pl10 pr10">
                          <DropDownChonCoQuanDieuTra name="DropDownChonCoQuanDieuTra" className="col-25 mb0-18" label="Tên cơ quan" isValid={this.state.isValid} bindValidator={this} require selectedValue={this.state.coQuanDieuTra} onChange={this.onChange.bind(this, 'coQuanDieuTra')}/>
                          <InputNumber className="col-25 mb0-18" name="soVuGiaoCoQuanDieuTra" label="Số vụ" value={Number(this.state.soVuGiaoCoQuanDieuTra)} onChange={this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra')}/>
                          <InputNumber className="col-25 mb0-18" name="soDoiTuongGiaoCoQuanDieuTra" label="Số đối tượng" value={Number(this.state.soDoiTuongGiaoCoQuanDieuTra)} onChange={this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra')} maxLength={255}/>
                          <ShowIf condition={this.state.allowAttachGiaoCoQuanDieuTra}>
                            <div className="col-100 pt15">
                              <ContainerFileDinhKem name="GiaoCQDT" onSave={this.state.onSave} phanLoaiQuyTrinh='GIAO_CO_QUAN_DIEU_TRA' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.taiLieuVanThuGiaoCoQuanDieuTra} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                            </div>
                          </ShowIf>
                        </div>
                      </div>
                      <div className="col-100 pt5 pb15">
                        <span className="line-border"></span>
                      </div>

                      <div className="col-100">
                        <ShowIfCheck label="Khởi tố" onChange={this.handleCheck.bind(this, 'khoiTo')} checked={this.state.khoiTo}>
                          <div className="col-100 no-gutter mt5 pb20">
                            <h2 className="title-12 mb15">Khởi tố</h2>
                            <div className="row pl10 pr10">
                              <div className="col-50 no-gutter">
                                <InputNumber className="col-50 mb0-18" name="soVuBiKhoiTo" label="Số vụ" value={this.state.soVuBiKhoiTo} onChange={this.onChange.bind(this, 'soVuBiKhoiTo')}/>
                                <InputNumber className="col-50 mb0-18" name="soDoiTuongBiKhoiTo" label="Số đối tượng" value={this.state.soDoiTuongBiKhoiTo} onChange={this.onChange.bind(this, 'soDoiTuongBiKhoiTo')} maxLength={255}/>
                              </div>
                            </div>
                          </div>
                        </ShowIfCheck>
                      </div>
                    </ShowIfCheck>
                  </div>
                </div>
              </ShowIf>
            </ShowIf>
            <ShowIf condition={this.state.allowAttach}>
              <div className="col-100 pb5">
                <ContainerFileDinhKem name="TaiLieuVTGQD" onSave={this.state.onSave} label="Danh sách văn bản xử lý" bindValidator={this} dataShow={this.state.listTaiLieuVanThuGiaiQuyetDonView} loaiVanBanSuggest={this.state.loaiVanBanSuggest}
                  ngayQuyetDinhSuggest={this.state.ngayQuyetDinhSuggest} data={this.state.listTaiLieuVanThuGiaiQuyetDon} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
              </div>
            </ShowIf>
            <div className="box-bottom col-100 gqd-wrap">
              <div className="wrap-big-line mt10 mb20"><div className="line-border"></div></div>
              <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
              <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI'}>
                <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this, 'openDialog')}><span>Chuyển theo dõi thực hiện</span></Link>
              </ShowIf>
              <ShowIf condition={this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM' || this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG'}>
                <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.handleGiaiQuyetDon.bind(this, 'giaoCanBo')}><span>Giao việc</span></Link>
              </ShowIf>
              <ShowIf condition={this.state.nextState == 'TRUONG_PHONG_NHAN_KET_QUA_TTXM'}>
                <ShowIf condition={this.state.typeButton == 'PHONG_NOI_CHINH'}>
                  <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this, 'openDialogNoiChinh')}><span>Chuyển cho phòng Nội chính</span></Link>
                </ShowIf>
                <ShowIf condition={this.state.typeButton == 'VAN_PHONG_UBND'}>
                  <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this, 'openDialogVanPhong')}><span>Chuyển cho VP UBND Tỉnh</span></Link>
                </ShowIf>
                <ShowIf condition={this.state.typeButton != 'PHONG_NOI_CHINH' && this.state.typeButton != 'VAN_PHONG_UBND'}>
                  <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.handleGiaiQuyetDon.bind(this, 'giaoPhongBan')}><span>Giao việc</span></Link>
                </ShowIf>
              </ShowIf>
              <ShowIf condition={this.state.nextState == 'KET_THUC' && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' && !this.props.isTTXMLai}>
                <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this, 'openDialogGiaoTTXML')}><span>Giao {lb1} lại</span></Link>
              </ShowIf>
              <ConfirmDialog open={this.state.openDialog} onClose={this.closeDialog.bind(this,'openDialog')} onSuccess={this.onSuccess.bind(this, 'openDialog')} title="Xác nhận" content={`Bạn có đồng ý chuyển đơn/vụ việc này cho ${this.state.tenDonViTheoDoiThucHien} theo dõi thực hiện không?`}/>
              <ConfirmDialog open={this.state.openDialogNoiChinh} onClose={this.closeDialog.bind(this,'openDialogNoiChinh')} onSuccess={this.onSuccess.bind(this, 'openDialogNoiChinh')} title="Xác nhận" content="Bạn có đồng ý chuyển đơn/vụ việc này cho phòng Nội chính không?"/>
              <ConfirmDialog open={this.state.openDialogVanPhong} onClose={this.closeDialog.bind(this,'openDialogVanPhong')} onSuccess={this.onSuccess.bind(this, 'openDialogVanPhong')} title="Xác nhận" content="Bạn có đồng ý chuyển đơn/vụ việc này cho VP UBND Tỉnh không?"/>
              <ConfirmDialog open={this.state.openDialogGiaoTTXML} onClose={this.closeDialog.bind(this,'openDialogGiaoTTXML')} onSuccess={this.onSuccess.bind(this, 'openDialogGiaoTTXML')} title="Xác nhận" content={`Bạn có đồng ý chuyển đơn/vụ việc này cho ${this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : ''} ${lb2} lại không?`}/>
            </div>
          </div>
          <Dialog
            isOpen={this.state.open}
            onClose={this.closeDialogConfirm.bind(this)}
            title='Xác nhận'
            className="reception-dialog delete-dialog wrap-block"
          >
            <div className="pt-dialog-body">
              <p className="reception-dialog-text">{this.state.message}</p>
            </div>
            <div className="box-bottom col-100">
              <Link className="btn-action btn-close action-todo" onClick={this.closeDialogConfirm.bind(this)}><span>Không</span></Link>
              <Link className="btn-green" onClick={this.onSuccessDialogConfirm.bind(this)}><span>Đồng ý</span></Link>
            </div>
          </Dialog>
        </form>
      </section>
    );
  }
}

TruongPhongNhanBaoCaoTTXM.defaultProps = {
  isTTXMLai: false,
  dataKetLuanNoiDungKhieuNai: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
}

let bindStateToProps = state => {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  }
}

export default connect(bindStateToProps)(TruongPhongNhanBaoCaoTTXM);



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/TruongPhongNhanBaoCaoTTXM.jsx